export const SPREADSHEET_IMPORT_QUERY_PARAM = 'import-spreadsheet';

const SPREADSHEET_IMPORT_STORAGE_KEY = 'file-browser-spreadsheet-import';

export const storePendingSpreadsheetImport = (item) => {
  sessionStorage.setItem(SPREADSHEET_IMPORT_STORAGE_KEY, JSON.stringify(item));
};

export const consumePendingSpreadsheetImport = () => {
  const serializedItem = sessionStorage.getItem(SPREADSHEET_IMPORT_STORAGE_KEY);
  sessionStorage.removeItem(SPREADSHEET_IMPORT_STORAGE_KEY);

  if (!serializedItem) {
    return null;
  }

  try {
    return JSON.parse(serializedItem);
  } catch (error) {
    console.error('Could not restore the spreadsheet selected in File Browser:', error);
    return null;
  }
};
